import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.min.css";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import * as message from "../../Constants/MessageConstant";
import ReactGA from "react-ga4";
import AccountPPU from "./AccountCreationPPU";
import AWSAccountPPU from "./AWSAccountCreationPPU";
import * as Constdata from "../../Constants/ApiConstants";
import SerraLoader from "../CommonComponent/Loader";
import SerraError from "../CommonComponent/Error";
import Hashmap from "hashmap";
import { connect } from "react-redux";
import {
  reset,
  setDataSourcePayload,
  setDataSourceRefreshStatus,
} from "../../reducers/dataSourcePayloadSlice";
import { apiFetch } from "../../Constants/CommonConstant";
import StandalonDS from "../free_trail_sign_up/StandalonDS";
import SaAccountCreationPPU from "./SaAccountCreationPPU";
import { resetRefreshTimer } from "../../reducers/datasSourceRefreshListener";

class MetricsDataSource extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.setErrorPopupState = this.setErrorPopupState.bind(this);
    this.toggleAccountPPU = this.toggleAccountPPU.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.fetchAllConfig = this.fetchAllConfig.bind(this);
    this.toggleDelete = this.toggleDelete.bind(this);
    this.showError = this.showError.bind(this);
    this.enableDisableConfig = this.enableDisableConfig.bind(this);
    this.checkAll = this.checkAll.bind(this);
    this.manageCommonAction = this.manageCommonAction.bind(this);
    this.checkThis = this.checkThis.bind(this);
    this.freeTrialAnalysisList = this.freeTrialAnalysisList.bind(this);
    this.state = {
      disableCommon: false,
      modalupload: false,
      upload: false,
      modal: false,
      isEdit: false,
      modalAccountPPU: false,
      providerName: "",
      errormessage: "",
      errorPopup: false,
      disabledNotifiedIds: new Set(),
      disabledDatasources: [],
      modalLoader: false,
      modalDelete: false,
      isGoTo: false,
      isFetching: false,
      value: [],
      fields: {},
      result: [],
      disableVmManagement: true,
      isFreeTrial: false,
      isFreeTrialCompleted: false,
      isRedirect: true,
      selectedMap: new Hashmap(),
      enableRefresh: false,
      enableDelete: false,
      enableSwitch: true,
      swchecked: true,
      isFetchingStatus: false,
      currentVm: null,
      dataSourceName: null,
      isFreeTrialAnalysisStarted: true,
    };
  }
  timeoutId = null;
  toggleAccountPPU = () => {
    this.setState((prevState) => ({
      modalAccountPPU: !prevState.modalAccountPPU,
      isEdit: false,
    }));
  };
  toggleDelete = () => {
    this.setState((prevState) => ({
      modalDelete: !prevState.modalDelete,
    }));
  };
  checkThis = async (id) => {
    var ck = document.getElementById(id + "select");
    var { selectedMap } = this.state;
    var checkedCount = 0;
    this.state.value.map(async (key) => {
      if (document.getElementById(key.id + "select").checked === true) {
        checkedCount++;
      }
    });
    if (ck.checked === true) {
      selectedMap.set(id, id + "select");
    } else {
      selectedMap.delete(id);
    }
    if (checkedCount === this.state.value.length) {
      document.getElementById("ckAll").checked = true;
      this.checkAll();
    } else {
      document.getElementById("ckAll").checked = false;
    }
    await this.setState({ selectedMap: selectedMap });
    await this.manageCommonAction();
    console.log(this.state.selectedMap);
  };
  checkAll = async () => {
    var { selectedMap } = this.state;
    var allck = document.getElementById("ckAll");
    this.state.value.map(async (key) => {
      if (key.status !== "FETCHING") {
        document.getElementById(key.id + "select").checked = allck.checked;
      }
      if (allck.checked === true) {
        if (key.status !== "FETCHING") {
          selectedMap.set(key.id, key.id + "select");
        }
      } else {
        selectedMap.delete(key.id);
      }
    });
    await this.setState({ selectedMap: selectedMap });
    await this.manageCommonAction();
    // console.log('selectedMap', this.state.selectedMap);
  };

  async manageCommonAction() {
    var enbRfsh = false;
    var enbDel = false;
    var enableSw = true;
    var enabledMap = new Hashmap();
    var disabledMap = new Hashmap();

    if (this.state.selectedMap.count() > 0) {
      this.state.value.map(async (key) => {
        let isAnyPricFetching = false;
        if (this.state.providerName === "AWS") {
          isAnyPricFetching = false;
        } else if (this.state.providerName === "AZURE") {
          if (key.azureSubscriptions.length > 0) {
            key.azureSubscriptions.map((Sb, i) => {
              if (
                Sb.priceThreadStatus !== null &&
                Sb.priceThreadStatus.toLowerCase().includes("fetching")
              ) {
                isAnyPricFetching = true;
              }
            });
          }
        } else if (this.state.providerName === "STANDALONE") {
          isAnyPricFetching = false;
        }
        if (
          this.state.selectedMap.has(key.id) &&
          !key.status.toLowerCase().includes("fetching") &&
          !isAnyPricFetching
        ) {
          enbRfsh = true;
          enbDel = true;
          if (key.isCPOEnabled) {
            enabledMap.set(key.id, key.id);
          } else {
            disabledMap.set(key.id, key.id);
          }
        }
      });
      if (this.state.selectedMap.count() === enabledMap.count()) {
        await this.setState({ swchecked: true });
        enableSw = false;
      } else if (this.state.selectedMap.count() === disabledMap.count()) {
        await this.setState({ swchecked: false });
        enableSw = false;
      }
    }
    await this.setState({
      enableRefresh: enbRfsh,
      enableDelete: enbDel,
      enableSwitch: enableSw,
    });
  }

  enableDisableConfig(id, isCPOStatus) {
    this.setState({ modalLoader: true });
    // var ck = document.getElementById("cpoSwitch");
    // var isChecked = ck.checked;
    var callurl = !isCPOStatus
      ? Constdata.ENABLE_CONFIG
      : Constdata.DISABLE_CONFIG;
    const payload = {
      configIds: [id],
    };

    fetch(`${callurl}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(async (responseJson) => {
        console.log(responseJson);
        // var { selectedMap } = this.state;
        // selectedMap.clear();
        // this.setState({ selectedMap: selectedMap });
        // var allck = document.getElementById("ckAll");
        // allck.checked = false;
        if (responseJson.success === true) {
          if (responseJson.orgInfo.providerName === "AWS") {
            await this.setState({ value: responseJson.data.awsConfigs });
          } else if (responseJson.orgInfo.providerName === "AZURE") {
            await this.setState({ value: responseJson.data.configs });
          } else if (responseJson.orgInfo.providerName === "STANDALONE") {
            await this.setState({ value: responseJson.data.standaloneConfigs });
          }

          if (this.state.value.length === 0) {
            this.setState({ modalAccountPPU: true });
          } else {
            var status = !isCPOStatus ? "EnableDS" : "DisableDS";
            await this.fetchAllConfig(status);
            await this.props.checkRefresh(status);
          }
          // this.state.value.length > 0 && this.state.value.map(async (key) => {
          //     document.getElementById(key.id + "select").checked = false;
          // });
          await this.setState({ modalLoader: false });
        } else if (
          responseJson.success === false &&
          responseJson.message === "No organization found"
        ) {
          this.setState({ modalLoader: false });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            isRedirect: true,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
            isRedirect: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          isErrorHeader: false,
          isRedirect: false,
        });
      });
  }
  async componentDidMount() {
    // ReactGA.initialize(message.MeasurementId);
    // ReactGA.send({
    //   hitType: "pageview",
    //   page: window.location.pathname,
    //   title: "Data Sources",
    // });
    await this.props.registerListners();
    await this.fetchAllConfig(1);
  }
  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId); // Clear timeout on component unmount
      this.timeoutId = null;
    }
  }

  async freeTrialAnalysisList(orgData) {
    if (orgData && orgData.freeTrialAnalysisList !== null) {
      const allEmpty = orgData.freeTrialAnalysisList.every(
        (item) => item === "" || item === null
      );
      return await !allEmpty;
    }
  }

  // A config is failed if its access status errored, or (for AWS) its price
  // source failed, or (for Azure) any subscription's price thread failed -
  // matches the isAccessFailed/isPricingFailed checks used per-row below, so
  // the banner/popup agree with what the table shows for the same config.
  isConfigFailed = (cfg) => {
    const isAccessFailed =
      cfg.status &&
      cfg.status !== "OK" &&
      cfg.status !== "FETCHING" &&
      cfg.status !== "WARNING";
    let isPricingFailed = false;
    if (this.state.providerName === "AWS") {
      isPricingFailed = cfg.priceSource === "fail";
    } else if (this.state.providerName === "AZURE") {
      if (cfg.azureSubscriptions && cfg.azureSubscriptions.length > 0) {
        isPricingFailed = cfg.azureSubscriptions.some(
          (sub) =>
            typeof sub.priceThreadStatus === "string" &&
            sub.priceThreadStatus.toLowerCase() !== "ok" &&
            sub.priceThreadStatus.toLowerCase() !== "fetching"
        );
      }
    }
    return isAccessFailed || isPricingFailed;
  };

  // The backend now records the real failure reason in statusReason for a
  // pricing-only failure too (AzureResourcesPricingService / AWSResourcesController
  // both persist a specific message there), so prefer that. Only fall back to a
  // generic message for stale/legacy records the backend hasn't re-touched yet
  // (statusReason still literally "OK" even though pricing is actually failed).
  // Determines AWS vs Azure from the shape of cfg itself (presence of
  // azureSubscriptions vs priceSource) rather than this.state.providerName,
  // so this can never disagree with what's actually on cfg.
  getFailureReason = (cfg) => {
    const isAccessFailed =
      cfg.status &&
      cfg.status !== "OK" &&
      cfg.status !== "FETCHING" &&
      cfg.status !== "WARNING";
    if (isAccessFailed) {
      return cfg.statusReason || "Unknown error";
    }
    const isPricingFailed =
      cfg.azureSubscriptions !== undefined
        ? cfg.azureSubscriptions &&
          cfg.azureSubscriptions.some(
            (sub) =>
              typeof sub.priceThreadStatus === "string" &&
              sub.priceThreadStatus.toLowerCase() !== "ok" &&
              sub.priceThreadStatus.toLowerCase() !== "fetching"
          )
        : cfg.priceSource === "fail";
    if (isPricingFailed) {
      const staleReason =
        !cfg.statusReason || cfg.statusReason.toUpperCase() === "OK";
      return staleReason ? "SKU information unavailable" : cfg.statusReason;
    }
    return cfg.statusReason || "Unknown error";
  };

  fetchAllConfig = async (type) => {
    this.props.registerListners(true);
    apiFetch(Constdata.GETALLACCOUNT_URL, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then(async (responseJson) => {
        let isFreeTrialCompleted = false;
        if (responseJson.success === true) {
          if (responseJson.orgInfo.plan === "FREE_TRIAL") {
            isFreeTrialCompleted =
              responseJson.orgInfo.isVmFreeTrialCompleted ||
              responseJson.orgInfo.isAspFreeTrialCompleted ||
              responseJson.orgInfo.isDbFreeTrialCompleted ||
              responseJson.orgInfo.isCleanupFreeTrailCompleted ||
              responseJson.orgInfo.isParkingFreeTrialCompleted;
          }

          this.setState({
            isFreeTrialAnalysisStarted:
              responseJson.orgInfo.freeTrialAnalysisList !== null &&
              responseJson.orgInfo.plan === "FREE_TRIAL" &&
              responseJson.orgInfo.userName !== "support@serralabs.com"
                ? await this.freeTrialAnalysisList(responseJson.orgInfo)
                : false,
          });

          if (this.props.dataSourcePayload) {
            this.props.dataSourcePayload.map((ds) => {
              if (ds.isEdit) {
                if (responseJson.orgInfo.providerName === "AWS") {
                  var findIndexAWS =
                    responseJson.data.awsConfigs &&
                    responseJson.data.awsConfigs.findIndex(
                      (val) => val.awsKey === ds.awsKey
                    );
                  if (findIndexAWS !== -1) {
                    responseJson.data.awsConfigs[findIndexAWS].status =
                      "FETCHING";
                    responseJson.data.awsConfigs[findIndexAWS].statusReason =
                      "Fetching";
                  }
                } else if (responseJson.orgInfo.providerName === "AZURE") {
                  var findIndex = responseJson.data.configs.findIndex(
                    (val) => val.tenantId === ds.tenantId
                  );
                  if (findIndex !== -1) {
                    responseJson.data.configs[findIndex].status = "FETCHING";
                    responseJson.data.configs[findIndex].statusReason =
                      "Fetching";
                  }
                } else {
                  var findIndexsa =
                    responseJson.data.standaloneConfigs.findIndex(
                      (val) => val.tenantId === ds.tenantId
                    );
                  if (findIndexsa !== -1) {
                    responseJson.data.standaloneConfigs[findIndexsa].status =
                      "FETCHING";
                    responseJson.data.standaloneConfigs[
                      findIndexsa
                    ].statusReason = "Fetching";
                  }
                }
              }
            });
          }

          const prevConfigsById = new Map(
            (this.state.value || []).map((c) => [c.id, c])
          );

          if (responseJson.orgInfo.providerName === "AWS") {
            await this.setState({
              value: responseJson.data.awsConfigs,
              providerName: "AWS",
              modalLoader: false,
              isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
              isFreeTrialCompleted: isFreeTrialCompleted,
            });
          } else if (responseJson.orgInfo.providerName === "AZURE") {
            await this.setState({
              value: responseJson.data.configs,
              providerName: "AZURE",
              modalLoader: false,
              isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
              isFreeTrialCompleted: isFreeTrialCompleted,
            });
          } else {
            await this.setState({
              value: responseJson.data?.standaloneConfigs || [],
              providerName: "STANDALONE",
              modalLoader: false,
              isFreeTrial: responseJson.orgInfo.plan === "FREE_TRIAL",
              isFreeTrialCompleted: isFreeTrialCompleted,
            });
          }

          // Persistent banner state (always reflects current reality, unlike the
          // one-time popup above which only fires on the healthy->failed edge).
          // Driven purely by isConfigFailed rather than the backend isCPOEnabled
          // flag - a pricing-only failure (set asynchronously by the price-fetch
          // helper) doesn't always flip isCPOEnabled, so gating on that flag left
          // this banner/popup silent even though the row itself showed an error.
          const currentlyDisabled = (this.state.value || []).filter((cfg) =>
            this.isConfigFailed(cfg)
          );
          this.setState({ disabledDatasources: currentlyDisabled });

          // Surface a popup the moment a datasource starts failing (price-fetch
          // or access error), instead of silently greying it out. Only fires
          // once per datasource (until it recovers) so the 5s poll loop doesn't
          // re-show it every tick while others still fetch.
          const justDisabled = (this.state.value || []).filter((cfg) => {
            const prevCfg = prevConfigsById.get(cfg.id);
            return (
              this.isConfigFailed(cfg) &&
              (!prevCfg || !this.isConfigFailed(prevCfg)) &&
              !this.state.disabledNotifiedIds.has(cfg.id)
            );
          });
          if (justDisabled.length > 0) {
            const updatedNotifiedIds = new Set(this.state.disabledNotifiedIds);
            justDisabled.forEach((cfg) => updatedNotifiedIds.add(cfg.id));
            const detail = justDisabled
              .map((cfg) => `${cfg.accountname}: ${this.getFailureReason(cfg)}`)
              .join("<br/>");
            this.setState({
              disabledNotifiedIds: updatedNotifiedIds,
              errorPopup: false,
              isErrorHeader: false,
              isRedirect: false,
              errormessage:
                "The following data source(s) have been disabled due to an error and will be excluded from VM analysis until the issue is fixed:<br/>" +
                detail,
            });
          }
          // Clear the notified flag for anything that's healthy again,
          // so a future failure on the same datasource pops up again.
          const stillFailedIds = new Set(
            (this.state.value || [])
              .filter((cfg) => this.isConfigFailed(cfg))
              .map((cfg) => cfg.id)
          );
          if (
            [...this.state.disabledNotifiedIds].some(
              (id) => !stillFailedIds.has(id)
            )
          ) {
            const prunedIds = new Set(
              [...this.state.disabledNotifiedIds].filter((id) =>
                stillFailedIds.has(id)
              )
            );
            this.setState({ disabledNotifiedIds: prunedIds });
          }

          let isFetching = false;
          this.setState({ isFetchingStatus: false });
          let failedCount = 0;
          this.state.value.map(async (key) => {
            let isAnyPricFetching = false;
            if (
              responseJson.orgInfo.providerName === "AWS" ||
              responseJson.orgInfo.providerName === "STANDALONE"
            ) {
              isAnyPricFetching = false;
            } else {
              if (key.azureSubscriptions.length > 0) {
                key.azureSubscriptions.map((Sb, i) => {
                  if (
                    Sb.priceThreadStatus !== null &&
                    Sb.priceThreadStatus.toLowerCase().includes("fetching")
                  ) {
                    isAnyPricFetching = true;
                  }
                });
              }
            }
            if (
              key.status.toLowerCase().includes("fetching") ||
              isAnyPricFetching
            ) {
              isFetching = true;
              this.setState({ isFetchingStatus: true });
            }
            if (
              key.status.toLowerCase().includes("fail") &&
              key.statusReason !== "Fetching interrupted by user"
            ) {
              failedCount++;
            }
          });
          var disableNext =
            failedCount === this.state.value.length ||
            !responseJson.data.enableNext;
          if (responseJson.data.enableNext) {
            disableNext = !responseJson.data.enableNext;
          }
          await this.setState({ disableVmManagement: disableNext });

          if (!isFetching) {
            if (this.timeoutId) {
              clearTimeout(this.timeoutId); // Clear the previous timeout if it exists
            }
            this.setState({ fetchFlag: false });
            if (type !== 1) {
              await this.props.checkRefresh(type);
            }
          } else {
            if (this.timeoutId) {
              clearTimeout(this.timeoutId); // Clear the previous timeout if it exists
              this.timeoutId = null;
            }
            if (this.props.isOpenModal) {
              this.timeoutId = setTimeout(() => {
                this.fetchAllConfig();
              }, 5000);
            }
          }
          if (
            this.props.isOpenModal &&
            !this.state.value.find(
              (val) =>
                val.status.toLowerCase().includes("fetching") &&
                val.refreshResourceIndex > 0
            )
          ) {
            this.props.setDataSourceRefreshStatus({
              refreshStatus: [],
              isRefreshDSAPI: false,
            });
          }
          await this.manageCommonAction();
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            isRedirect: true,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            isRedirect: false,
            modalLoader: false,
            errorPopup: true,
            errormessage: responseJson.message || message.ServerError,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.ServerError,
          isRedirect: false,
          isErrorHeader: false,
        });
      });
  };
  handleEdit = (key) => {
    fetch(`${Constdata.GETAZURECONFIG_URL}${key}`, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }
        return response.json();
      })
      .then((responseJson) => {
        console.log(responseJson);
        if (responseJson.success === true) {
          var prefieldData = {};
          if (responseJson.orgInfo.providerName === "AWS") {
            prefieldData = {
              accountname: responseJson.data.accountname,
              accountKey: responseJson.data.awsKey,
              accountSecret: responseJson.data.awsSecret,
              storeSecret: responseJson.data.storeSecret,
              id: key,
              isCPOEnabled: responseJson.data.isCPOEnabled,
              region: responseJson.data.region,
              status: responseJson.data.status,
              statusReason: responseJson.data.statusReason,
              priceSource: responseJson.data.priceSource,
            };
          } else if (responseJson.orgInfo.providerName === "AZURE") {
            prefieldData = {
              accountname: responseJson.data.accountname,
              tenantId: responseJson.data.tenantId,
              clientSecret: responseJson.data.clientSecret,
              clientId: responseJson.data.clientId,
              storeSecret: responseJson.data.storeSecret,
              id: key,
              isCPOEnabled: responseJson.data.isCPOEnabled,
              region: responseJson.data.region,
              status: responseJson.data.status,
              statusReason: responseJson.data.statusReason,
              azureSubscriptions: responseJson.data.azureSubscriptions,
            };
          } else {
            prefieldData = {
              accountname: responseJson.data.accountname,
              tenantId: responseJson.data.staticIp,
              clientSecret: responseJson.data.password,
              clientId: responseJson.data.userName,
              // storeSecret: responseJson.data.storeSecret,
              id: key,
              isCPOEnabled: responseJson.data.isCPOEnabled,
              region: responseJson.data.region,
            };
          }

          this.setState({
            fields: prefieldData,
            modalLoader: false,
            isEdit: true,
          });
          this.setState({ modalAccountPPU: true });
          this.fetchAllConfig();
        } else if (responseJson.success === false) {
          this.setState({
            isRedirect: false,
            modalLoader: false,
            errorPopup: true,
            errormessage: responseJson.message,
            isErrorHeader: false,
          });
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            isRedirect: true,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            isRedirect: false,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
          isRedirect: false,
        });
      });
  };
  handleDelete = () => {
    if (this.state.currentVm === "") {
      return;
    }
    this.setState({ modalLoader: true });

    const payload = {
      configIds: [this.state.currentVm],
    };
    apiFetch(Constdata.DELETESINGLEACCOUNT_URL, {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((responseJson) => {
        console.log(responseJson);
        var { selectedMap } = this.state;
        selectedMap.clear();
        this.setState({ selectedMap: selectedMap });
        if (responseJson.success === true) {
          this.setState({ modalLoader: false, modalDelete: false });
          this.fetchAllConfig("DeleteDS");
          this.props.checkRefresh("DeleteDS");
          this.props.history.push("/dashboard");
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            modalDelete: false,
            isRedirect: true,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalDelete: false,
            isRedirect: false,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalDelete: false,
          modalLoader: false,
          errorPopup: true,
          errormessage: message.CacheErrorText,
          isErrorHeader: false,
          isRedirect: false,
        });
      });
  };
  toggle = () => {
    this.setState((prevState) => ({
      modal: !prevState.modal,
    }));
  };
  setErrorPopupState = (event) => {
    this.setState({ errorPopup: event });
    if (this.state.isRedirect) {
      this.props.history.push("/");
    }
  };
  showError(msg) {
    if (msg.includes("Application (ClientID) Role Issue")) {
      this.setState({
        isRedirect: false,
        modalLoader: false,
        errorPopup: true,
        errormessage:
          this.state.providerName === "AWS"
            ? message.AwsTestErrorMsg
            : message.AzureTestErrorMsg,
      });
    } else {
      this.setState({
        isRedirect: false,
        modalLoader: false,
        errorPopup: true,
        errormessage: msg,
      });
    }
  }

  enableRefresh(key) {
    let isAnyPricFetching = false;
    if (this.state.providerName === "AWS") {
      isAnyPricFetching = false;
    } else if (this.state.providerName === "AZURE") {
      if (key.azureSubscriptions.length > 0) {
        key.azureSubscriptions.map((Sb, i) => {
          if (
            Sb.priceThreadStatus !== null &&
            Sb.priceThreadStatus.toLowerCase().includes("fetching")
          ) {
            isAnyPricFetching = true;
          }
        });
      }
    }
    if (
      key.id &&
      !key.status.toLowerCase().includes("fetching") &&
      !isAnyPricFetching
    ) {
      return true;
    } else {
      return false;
    }
  }

  handleRefreshIndividual(id) {
    this.props.resetRefreshTimer();
    const payload = {
      configIds: [id],
    };
    this.setState({ isFetchingStatus: true });
    let newValues = [];
    this.state.value.map((Vm, i) => {
      if (Vm.id === id) {
        Vm.status = "FETCHING";
      }
      newValues.push(Vm);
    });
    this.setState({ value: newValues });

    const fetchingAccounts = newValues.filter((item) =>
      item.status?.toLowerCase().includes("fetching")
    );
    const accountNames = fetchingAccounts.map((item) => item.accountname);
    this.props.setDataSourceRefreshStatus({ refreshStatus: accountNames });

    this.manageCommonAction();
    fetch(`${Constdata.SELECT_REFRESH}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then(async (responseJson) => {
        if (responseJson.success === true) {
          this.props.setDataSourceRefreshStatus({ isRefreshDSAPI: true });
          if (responseJson.orgInfo.providerName === "AWS") {
            await this.setState({
              value: responseJson.data.awsConfigs,
              providerName: "AWS",
              modalLoader: false,
            });
          } else {
            await this.setState({
              value: responseJson.data.configs,
              providerName: "AZURE",
              modalLoader: false,
            });
          }
          if (this.state.value.length === 0) {
            this.setState({ modalAccountPPU: true });
          }

          let isFetching = false;
          let failedCount = 0;
          this.state.value.map(async (key) => {
            if (key.status.toLowerCase().includes("fetching")) {
              isFetching = true;
            }
            if (key.status.toLowerCase().includes("fail")) {
              failedCount++;
            }
          });
          var disableNext =
            failedCount === this.state.value.length ||
            !responseJson.data.enableNext;
          if (responseJson.data.enableNext) {
            disableNext = !responseJson.data.enableNext;
          }
          await this.setState({ disableVmManagement: disableNext });
          if (!isFetching) {
            this.props.setDataSourceRefreshStatus({
              isRefreshDSAPI: false,
              refreshStatus: [],
            });
            this.setState({ isFetchingStatus: false });
            if (this.timeoutId) {
              clearTimeout(this.timeoutId); // Clear the previous timeout if it exists
            }
            await this.props.checkRefresh();
          } else {
            this.timeoutId = setTimeout(() => {
              this.fetchAllConfig();
            }, 5000);
          }
        } else if (responseJson.status === 403 || responseJson.status === 401) {
          this.setState({
            isRedirect: true,
            modalLoader: false,
            errorPopup: true,
            errormessage: message.SessionExpiredText,
            isErrorHeader: false,
          });
        } else {
          this.setState({
            modalLoader: false,
            errorPopup: true,
            errormessage: message.ServerError,
            isErrorHeader: false,
            isRedirect: false,
          });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          modalLoader: false,
          errorPopup: true,
          isErrorHeader: false,
          isRedirect: false,
        });
        this.props.setDataSourceRefreshStatus({
          isRefreshDSAPI: false,
          refreshStatus: [],
        });
      });
  }

  updateStatusOnSubmit = (id, type) => {
    if (type === "AWS") {
      var findIndex = this.state.value.findIndex((val) => val.awsKey === id);
      if (findIndex !== -1) {
        this.state.value[findIndex].status = "FETCHING";
        this.state.value[findIndex].statusReason = "Fetching";
        this.toggleAccountPPU();
      }
      this.props.checkRefresh("AddDS");
    } else {
      var findIndex = this.state.value.findIndex((val) => val.tenantId === id);
      if (findIndex !== -1) {
        this.state.value[findIndex].status = "FETCHING";
        this.state.value[findIndex].statusReason = "Fetching";
        this.toggleAccountPPU();
      }
    }
  };

  render() {
    return (
      <div>
        <div
          className="container-verf container-verf-margin pageBgWhite"
          style={{ borderRadius: "10px" }}
          role="main"
        >
          <div className="frm-container">
            {this.state.disabledDatasources &&
            this.state.disabledDatasources.length > 0 ? (
              <div
                role="alert"
                style={{
                  backgroundColor: "#FDECEA",
                  border: "1px solid #F5C2C0",
                  borderRadius: "4px",
                  padding: "12px 16px",
                  margin: "12px 16px",
                  color: "#611A15",
                  fontFamily: "Poppins, sans-serif",
                  fontSize: "14px",
                }}
              >
                <strong>
                  {this.state.disabledDatasources.length} datasource
                  {this.state.disabledDatasources.length > 1 ? "s" : ""}
                </strong>{" "}
                {this.state.disabledDatasources.length > 1
                  ? "have errors"
                  : "has an error"}{" "}
                and {this.state.disabledDatasources.length > 1 ? "are" : "is"}{" "}
                excluded from VM analysis:{" "}
                {this.state.disabledDatasources
                  .map(
                    (cfg) =>
                      `${cfg.accountname} (${this.getFailureReason(cfg)})`
                  )
                  .join(", ")}
              </div>
            ) : null}
            <div className="ManageAcntTable">
              <Table
                className="table-responsive"
                id="list_table"
                style={{
                  lineHeight: "3",
                  textAlign: "center",
                  overflow: "scroll",
                }}
              >
                <thead>
                  <tr>
                    <th>Data Source Name</th>
                    <th>Data Source Access Status</th>
                    <th>Data Source Pricing Status</th>
                    <th>Enable</th>
                    <th>Edit</th>
                    <th>Delete</th>
                    <th>Refresh</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.value &&
                    this.state.value.map((Vm, i) => {
                      var isAnyPricFetching = false;
                      if (
                        this.state.providerName === "AWS" ||
                        this.state.providerName === "STANDALONE"
                      ) {
                      } else {
                        if (Vm.azureSubscriptions.length > 0) {
                          Vm.azureSubscriptions.map((Sb, i) => {
                            if (
                              Sb.priceThreadStatus !== null &&
                              Sb.priceThreadStatus
                                .toLowerCase()
                                .includes("fetching")
                            ) {
                              isAnyPricFetching = true;
                            }
                          });
                        }
                      }

                      // Access status has failed if it's not OK, not currently
                      // fetching, and not a soft WARNING - i.e. the "No" branch
                      // rendered in the Data Source Access Status column below.
                      var isAccessFailed =
                        Vm.status !== "OK" &&
                        Vm.status !== "FETCHING" &&
                        Vm.status !== "WARNING";

                      // Pricing status has failed if AWS's own price source
                      // came back "fail", or any Azure subscription's price
                      // thread settled on something other than ok/fetching
                      // (i.e. the "Unavailable" branch rendered below).
                      var isPricingFailed = false;
                      if (this.state.providerName === "AWS") {
                        isPricingFailed = Vm.priceSource === "fail";
                      } else if (this.state.providerName === "AZURE") {
                        if (
                          Vm.azureSubscriptions !== undefined &&
                          Vm.azureSubscriptions !== null &&
                          Vm.azureSubscriptions.length > 0
                        ) {
                          isPricingFailed = Vm.azureSubscriptions.some(
                            (Sb) =>
                              Sb.priceThreadStatus !== null &&
                              Sb.priceThreadStatus.toLowerCase() !== "ok" &&
                              Sb.priceThreadStatus.toLowerCase() !== "fetching"
                          );
                        }
                      }
                      var isEnableDisabled =
                        Vm.status === "FETCHING" ||
                        isAnyPricFetching ||
                        isAccessFailed ||
                        isPricingFailed;

                      return (
                        <tr id="list_tablerow">
                          <td
                            style={{
                              opacity:
                                Vm.isCPOEnabled && Vm.status !== "FETCHING"
                                  ? 1
                                  : 0.5,
                              fontStyle: Vm.isCPOEnabled ? "" : "italic",
                            }}
                          >
                            {Vm.accountname}{" "}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              opacity:
                                Vm.isCPOEnabled && Vm.status !== "FETCHING"
                                  ? 1
                                  : 0.5,
                              fontStyle: Vm.isCPOEnabled ? "" : "italic",
                            }}
                          >
                            {Vm.status === "OK" ? (
                              "Yes"
                            ) : Vm.status === "FETCHING" ? (
                              <div>
                                <i
                                  className="fa fa-circle-o-notch fa-spin"
                                  aria-hidden="true"
                                  data-toggle="tooltip"
                                  data-placement="right"
                                  title={"Checking"}
                                />
                                Checking
                              </div>
                            ) : Vm.status === "WARNING" ? (
                              Vm.statusReason
                            ) : (
                              <div>
                                No{" "}
                                <i
                                  className="fa fa-warning"
                                  style={{
                                    fontSize: "15px",
                                    color: "#e6da12",
                                    paddingLeft: "5px",
                                  }}
                                  data-placement="right"
                                  title={Vm.statusReason}
                                >
                                  {" "}
                                </i>
                              </div>
                            )}
                          </td>

                          <td
                            style={{
                              opacity:
                                Vm.isCPOEnabled && Vm.status !== "FETCHING"
                                  ? 1
                                  : 0.5,
                              fontStyle: Vm.isCPOEnabled ? "" : "italic",
                            }}
                          >
                            {this.state.providerName === "AWS" ? (
                              <>
                                {Vm.priceSource !== null ? (
                                  <>
                                    {Vm.priceSource !== "fail" ? (
                                      <div>Available </div>
                                    ) : null}
                                    <div>{Vm.priceSource}</div>
                                  </>
                                ) : (
                                  <div>
                                    <i
                                      className="fa fa-circle-o-notch fa-spin"
                                      aria-hidden="true"
                                      data-toggle="tooltip"
                                      data-placement="right"
                                      title={"Checking"}
                                    />
                                    Checking
                                  </div>
                                )}
                              </>
                            ) : Vm.azureSubscriptions !== undefined &&
                              Vm.azureSubscriptions !== null &&
                              Vm.azureSubscriptions.length > 0 ? (
                              Vm.azureSubscriptions.map((Sb, i) => {
                                return (
                                  <div>
                                    {Sb.priceThreadStatus !== null &&
                                    Sb.priceThreadStatus.toLowerCase() ===
                                      "ok" ? (
                                      Sb.priceSource !== null &&
                                      Sb.priceSource
                                        .toLowerCase()
                                        .includes("public") ? (
                                        <>
                                          <div>Available</div>
                                          <div>
                                            Using default Calculator pricing
                                          </div>
                                        </>
                                      ) : (
                                        <>
                                          <div>Available</div>
                                          <div
                                            style={{
                                              lineHeight: "1",
                                              paddingBottom: "10px",
                                            }}
                                          >
                                            {Sb.priceSource !== null ? (
                                              <>
                                                <div>Subscription Pricing</div>
                                                <div>
                                                  (
                                                  {Sb.priceSource !== null
                                                    ? Sb.priceSource.replace(
                                                        "Private-",
                                                        ""
                                                      )
                                                    : ""}
                                                  )
                                                </div>
                                              </>
                                            ) : (
                                              <div>
                                                Using default Calculator pricing
                                              </div>
                                            )}
                                          </div>
                                        </>
                                      )
                                    ) : Sb.priceThreadStatus !== null &&
                                      Sb.priceThreadStatus.toLowerCase() ===
                                        "fetching" ? (
                                      <div>
                                        <i
                                          className="fa fa-circle-o-notch fa-spin"
                                          aria-hidden="true"
                                          data-toggle="tooltip"
                                          data-placement="right"
                                          title="Checking"
                                        />
                                        Checking
                                      </div>
                                    ) : (
                                      <div>
                                        Unavailable{" "}
                                        <i
                                          className="fa fa-warning"
                                          style={{
                                            fontSize: "15px",
                                            color: "#e6da12",
                                            paddingLeft: "5px",
                                          }}
                                          data-placement="right"
                                          title="Internal error: SKU not available, contact Support@serralabs.com"
                                        >
                                          {" "}
                                        </i>
                                      </div>
                                    )}
                                  </div>
                                );
                              })
                            ) : (
                              <div>
                                Unavailable{" "}
                                <i
                                  className="fa fa-warning"
                                  style={{
                                    fontSize: "15px",
                                    color: "#e6da12",
                                    paddingLeft: "5px",
                                  }}
                                  data-placement="right"
                                  title="Internal error: SKU not available, contact Support@serralabs.com"
                                >
                                  {" "}
                                </i>
                              </div>
                            )}
                          </td>
                          <td>
                            <Input
                              type="radio"
                              name={"isCPOEnabled" + Vm.id}
                              checked={
                                Vm.isCPOEnabled &&
                                !isAccessFailed &&
                                !isPricingFailed
                                  ? true
                                  : false
                              }
                              disabled={isEnableDisabled}
                              onClick={() => {
                                if (isEnableDisabled) {
                                  return;
                                }
                                this.enableDisableConfig(
                                  Vm.id,
                                  Vm.isCPOEnabled
                                );
                              }}
                              style={{
                                marginLeft: "0px",
                                height: "25px",
                                width: "25px",
                                verticalAlign: "middle",
                                accentColor: "#29a4a8",
                                cursor: isEnableDisabled
                                  ? "not-allowed"
                                  : "pointer",
                              }}
                            />
                          </td>

                          <td
                            style={{
                              opacity: Vm.status === "FETCHING" ? 0.5 : 1,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "10px 0px",
                              }}
                            >
                              {this.state.isFreeTrialAnalysisStarted ||
                              Vm.status.toLowerCase().includes("fetching") ? (
                                <div outline style={{ cursor: "pointer" }}>
                                  <img
                                    src={require("../../images/EditIcon_Disabled_01.svg")}
                                    title="Edit"
                                  />
                                </div>
                              ) : (
                                <div
                                  outline
                                  onClick={() => {
                                    this.handleEdit(Vm.id);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={require("../../images/EditIcon_01.svg")}
                                    title="Edit"
                                  />
                                </div>
                              )}
                            </div>
                          </td>
                          <td
                            style={{
                              opacity: Vm.status === "FETCHING" ? 0.5 : 1,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "10px 0px",
                              }}
                            >
                              {this.state.isFreeTrialAnalysisStarted ||
                              Vm.status.toLowerCase().includes("fetching") ? (
                                <div outline style={{ cursor: "pointer" }}>
                                  <img
                                    src={require("../../images/DeleteIcon_Disabled_01.svg")}
                                    title="Delete"
                                  />
                                </div>
                              ) : (
                                <div
                                  outline
                                  onClick={() => {
                                    this.toggleDelete();
                                    this.setState({
                                      currentVm: Vm.id,
                                      dataSourceName: Vm.accountname,
                                    });
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    src={require("../../images/Delete_Icon.svg")}
                                    title="Delete"
                                  />
                                </div>
                              )}
                            </div>
                          </td>
                          <td>
                            {this.enableRefresh(Vm) ? (
                              <div
                                outline
                                onClick={() =>
                                  this.handleRefreshIndividual(Vm.id)
                                }
                                style={{
                                  marginRight: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  style={{ width: "45px" }}
                                  src={require("../../images/deep_refresh_sky.png")}
                                  title="Refresh Data Source"
                                />
                              </div>
                            ) : (
                              <div
                                outline
                                style={{
                                  marginRight: "10px",
                                  cursor: "pointer",
                                }}
                              >
                                <img
                                  style={{ width: "45px" }}
                                  src={require("../../images/deep_refresh_sky_disabled.png")}
                                  title="Refresh Data Source"
                                />
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })}

                  {this.props.dataSourcePayload &&
                    this.props.dataSourcePayload.map((Vm, i) => {
                      return !Vm.isEdit &&
                        this.state.value &&
                        (!this.state.value.some(
                          (val) => val?.tenantId == Vm?.tenantId
                        ) ||
                          !this.state.value.some(
                            (val) => val?.awsKey == Vm?.awsKey
                          ) ||
                          !this.state.value.some(
                            (val) => val?.staticIp == Vm?.staticIp
                          )) ? (
                        <tr id="list_tablerow">
                          <td
                            style={{
                              opacity:
                                Vm.isCPOEnabled && Vm.status !== "FETCHING"
                                  ? 1
                                  : 0.5,
                              fontStyle: Vm.isCPOEnabled ? "" : "italic",
                            }}
                          >
                            {Vm.accountname}{" "}
                          </td>
                          <td
                            style={{
                              textAlign: "center",
                              opacity:
                                Vm.isCPOEnabled && Vm.status !== "FETCHING"
                                  ? 1
                                  : 0.5,
                              fontStyle: Vm.isCPOEnabled ? "" : "italic",
                            }}
                          >
                            {Vm.status === "OK" ? (
                              "Yes"
                            ) : Vm.status === "FETCHING" ? (
                              <div>
                                <i
                                  className="fa fa-circle-o-notch fa-spin"
                                  aria-hidden="true"
                                  data-toggle="tooltip"
                                  data-placement="right"
                                  title={"Checking"}
                                />
                                Checking
                              </div>
                            ) : Vm.status === "WARNING" ? (
                              Vm.statusReason
                            ) : (
                              <div>
                                No{" "}
                                <i
                                  className="fa fa-warning"
                                  style={{
                                    fontSize: "15px",
                                    color: "#e6da12",
                                    paddingLeft: "5px",
                                  }}
                                  data-placement="right"
                                  title={Vm.statusReason}
                                >
                                  {" "}
                                </i>
                              </div>
                            )}
                          </td>

                          <td
                            style={{
                              opacity:
                                Vm.isCPOEnabled && Vm.status !== "FETCHING"
                                  ? 1
                                  : 0.5,
                              fontStyle: Vm.isCPOEnabled ? "" : "italic",
                            }}
                          >
                            <div>
                              <i
                                className="fa fa-circle-o-notch fa-spin"
                                aria-hidden="true"
                                data-toggle="tooltip"
                                data-placement="right"
                                title="Checking"
                              />
                              Checking
                            </div>
                          </td>
                          <td>
                            <Input
                              type="radio"
                              name={"isCPOEnabled" + i}
                              checked={false}
                              style={{
                                marginLeft: "0px",
                                height: "25px",
                                width: "25px",
                                verticalAlign: "middle",
                                accentColor: "#29a4a8",
                              }}
                            />
                          </td>

                          <td
                            style={{
                              opacity: Vm.status === "FETCHING" ? 0.5 : 1,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "10px 0px",
                              }}
                            >
                              <div outline style={{ cursor: "pointer" }}>
                                <img
                                  src={require("../../images/EditIcon_Disabled_01.svg")}
                                  title="Edit"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                margin: "10px 0px",
                              }}
                            >
                              <div outline style={{ cursor: "pointer" }}>
                                <img
                                  src={require("../../images/DeleteIcon_Disabled_01.svg")}
                                  title="Delete"
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <div
                              outline
                              style={{ marginRight: "10px", cursor: "pointer" }}
                            >
                              <img
                                src={require("../../images/RefreshIcon_Disabled_01.svg")}
                                title="Refresh Data Source"
                              />
                            </div>
                          </td>
                        </tr>
                      ) : null;
                    })}
                </tbody>
              </Table>
              <div
                className="btn-toolbar pageBgWhite"
                role="toolbar"
                aria-label="Toolbar with button groups"
                style={{
                  display: "flex",
                  padding: "20px",
                  justifyContent: "flex-end",
                  borderRadius: "0px 0px 10px 10px",
                }}
              >
                <div
                  className="btn-group mr-2"
                  role="group"
                  aria-label="Third group"
                >
                  <Button
                    id={
                      this.state.isFreeTrialAnalysisStarted
                        ? "listDisabledBtn"
                        : "listBtn"
                    }
                    onClick={this.toggleAccountPPU}
                    className="btn-detils"
                    disabled={this.state.isFreeTrialAnalysisStarted}
                  >
                    Add Data Source
                  </Button>
                  <Button className="btn listInfoBtn" onClick={this.toggle}>
                    <i className="fa fa-info" />
                  </Button>
                </div>
                <div role="group" aria-label="First group">
                  <Button
                    className="btn-cancel btn btn-light"
                    onClick={this.props.toggle}
                  >
                    Close
                  </Button>
                </div>
              </div>
            </div>
            <Modal
              size="lg"
              isOpen={this.state.modal}
              toggle={this.toggle}
              backdrop="static"
            >
              <ModalHeader
                id="modalheader_list"
                toggle={this.toggle}
                cssModule={{ "modal-title": "modalHeader" }}
              >
                <div
                  className="modalCompanyName"
                  dangerouslySetInnerHTML={{
                    __html: message.SerraLabsModalHeader,
                  }}
                />{" "}
                <div className="modalTitle">
                  {" "}
                  Add {this.state.providerName === "AWS" ? "AWS" : "Azure"}{" "}
                  Account
                </div>
              </ModalHeader>
              <ModalBody>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      this.state.providerName === "AWS"
                        ? message.AddAwsAccountText
                        : message.AddAzureAccountText,
                  }}
                />

                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      this.state.providerName === "AWS"
                        ? message.AwsClientInstructionText
                        : message.AzureClientInstructionText,
                  }}
                />
              </ModalBody>
              <ModalFooter id="knowMoreFooter">
                <Button id="confirmbtn_list" onClick={this.toggle}>
                  OK
                </Button>
              </ModalFooter>
            </Modal>
            <Modal
              size="lg"
              isOpen={this.state.modalAccountPPU}
              toggle={this.toggleAccountPPU}
              backdrop="static"
            >
              <ModalHeader
                id="modalheader_list"
                toggle={this.toggleAccountPPU}
                cssModule={{ "modal-title": "modalHeader" }}
              >
                <div
                  className="modalCompanyName"
                  dangerouslySetInnerHTML={{
                    __html: message.SerraLabsModalHeader,
                  }}
                />
              </ModalHeader>
              {
                //console.log("Inside metricdatasource providername = ", this.state.providerName);
                this.state.providerName === "AWS" ? (
                  <AWSAccountPPU
                    updateStatusOnSubmit={this.updateStatusOnSubmit}
                    addDataSourcesResponse={this.props.addDataSourcesResponse}
                    cancelAccount={this.toggleAccountPPU}
                    data={this.state.fields}
                    handleFetch={this.fetchAllConfig}
                    AccountEdit={this.state.isEdit}
                    dataRes={this.state.value}
                  ></AWSAccountPPU>
                ) : this.state.providerName === "STANDALONE" ? (
                  <SaAccountCreationPPU
                    updateStatusOnSubmit={this.updateStatusOnSubmit}
                    // addDataSourcesAzureResponse={
                    //   this.props.addDataSourcesAzureResponse
                    // }
                    cancelAccount={this.toggleAccountPPU}
                    data={this.state.fields}
                    handleFetch={this.fetchAllConfig}
                    AccountEdit={this.state.isEdit}
                    dataRes={this.state.value}
                  ></SaAccountCreationPPU>
                ) : (
                  <AccountPPU
                    updateStatusOnSubmit={this.updateStatusOnSubmit}
                    addDataSourcesAzureResponse={
                      this.props.addDataSourcesAzureResponse
                    }
                    cancelAccount={this.toggleAccountPPU}
                    data={this.state.fields}
                    handleFetch={this.fetchAllConfig}
                    AccountEdit={this.state.isEdit}
                    dataRes={this.state.value}
                  ></AccountPPU>
                )
              }
            </Modal>
            <Modal
              size="lg"
              isOpen={this.state.modalDelete}
              toggle={this.toggleDelete}
              backdrop="static"
            >
              <ModalHeader
                id="modalheader_list"
                toggle={this.toggleDelete}
                cssModule={{ "modal-title": "modalHeader" }}
              >
                <div
                  className="modalCompanyName"
                  dangerouslySetInnerHTML={{
                    __html: message.SerraLabsModalHeader,
                  }}
                />{" "}
                <div className="modalTitle"> Delete Azure Account</div>
              </ModalHeader>
              <ModalBody>
                Are you sure you want to delete data source{" "}
                {this.state.dataSourceName}?
              </ModalBody>
              <ModalFooter className="modalBtn" id="knowMoreFooter">
                <Button
                  id="confirmbtn_list"
                  onClick={() => {
                    this.handleDelete();
                  }}
                >
                  Go Ahead
                </Button>
                <Button id="confirmbtn_list" onClick={this.toggleDelete}>
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
        {this.state.modalLoader === true ? <SerraLoader></SerraLoader> : ""}
        {this.state.errorPopup === true ? (
          <SerraError
            Errordata={this.state.errormessage}
            ErrorPopup={this.state.errorPopup}
            setErrorMethod={this.setErrorPopupState}
            isError={this.state.isErrorHeader}
          ></SerraError>
        ) : (
          ""
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dataSourcePayload: state.dataSourcePayload.payload,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    resetDataSourcePayload: () => dispatch(reset()),
    setDataSourcePayload: (data) => dispatch(setDataSourcePayload(data)),
    // manual datasource refresh state
    setDataSourceRefreshStatus: (data) =>
      dispatch(setDataSourceRefreshStatus(data)),
    // 5 min datasource refresh state
    resetRefreshTimer: () => resetRefreshTimer(dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MetricsDataSource);
